import { $openSrv, $userSrv, $allSrv } from '@/plugin/axios'
// import request from '@/plugin/axios'
import CryptoJS from 'crypto-js'

function encrypt (input) {
  let key = CryptoJS.enc.Utf8.parse('ABCDEFGHIJKL_key')
  let iv = CryptoJS.enc.Utf8.parse('ABCDEFGHIJKLM_iv')
  let str = CryptoJS.enc.Utf8.parse(input)
  let encryptedInput = CryptoJS.AES.encrypt(str, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encryptedInput.ciphertext.toString().toUpperCase()
}

function login (form) {
  let data = {
    passport: encrypt(form.username),
    password: encrypt(form.password),
    captchaKey: form.captchaKey,
    captchaValue: form.captchaValue
  }
  let url = '/main/account/login'
  return $openSrv.post(url, {}, data)
}

function hostConfig () {
  let url = '/main/public/config'
  let data = {
    host: location.host
  }
  return $openSrv.get(url, data)
}

function captcha (key) {
  let data = {
    key: key
  }
  let url = '/main/account/captcha'
  return $openSrv.get(url, data)
}

function loadUserInfo () {
  return $userSrv.get('/main/user/profile', {})
}

function smsCode (data) {
  let url = '/main/account/smsCode'
  return $openSrv.post(url, {}, data)
}

function loginPhone (form) {
  let data = {
    passport: encrypt(form.passport),
    captchaKey: form.captchaKey,
    captchaValue: form.captchaValue
  }
  let url = '/main/account/loginPhone'
  return $openSrv.post(url, {}, data)
}

/**
 * 检查OAuth2是否启用
 */
function checkOAuth2Enabled () {
  return $allSrv.get('/oauth2/hos/enabled', {})
}

/**
 * 获取OAuth2认证URL
 */
function getAuthorizationUrl () {
  return $allSrv.get('/oauth2/hos/authorize', {})
}

/**
 * OAuth2登录
 * @param {string} code - 授权码
 */
function oauth2Login (code) {
  return $allSrv.post('/oauth2/hos/login', {}, { code })
}

/**
 * 单点登出
 * @param {string} accessToken - HOS访问令牌
 */
function oauth2Logout (accessToken) {
  return $allSrv.post('/oauth2/hos/logout', {}, { access_token: accessToken })
}

/**
 * 根据医疗机构名称模糊查询
 * @param {string} title - 医疗机构名称
 */
function getHospitalList (pageIndex, pageSize, title) {
  let data = {
    pageIndex: pageIndex || 1,
    pageSize: pageSize || 20,
    title: title
  }
  let url = '/main/public/hospitalList'
  return $openSrv.get(url, data)
}

// 注册新用户
function register (form) {
  let data = {
    userName: form.username,
    password: form.password,
    realName: form.realName,
    phone: form.phone,
    hospitalId: form.hospitalId,
    verificationCode: form.verificationCode,
    retypePassword: form.confirmPassword,
    passport: encrypt(form.phone)
  }
  let url = 'main/account/register'
  return $openSrv.post(url, {}, data)
}

export default {
  login: login,
  loadUserInfo: loadUserInfo,
  hostConfig: hostConfig,
  captcha: captcha,
  smsCode: smsCode,
  loginPhone: loginPhone,
  checkOAuth2Enabled: checkOAuth2Enabled,
  getAuthorizationUrl: getAuthorizationUrl,
  oauth2Login: oauth2Login,
  oauth2Logout: oauth2Logout,
  getHospitalList: getHospitalList,
  register: register
}
